import { render, staticRenderFns } from "./ProductEditorPrices.vue?vue&type=template&id=640caef6&"
import script from "./ProductEditorPrices.vue?vue&type=script&lang=js&"
export * from "./ProductEditorPrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports